export default (itemsCount, itemsPerGroup) => {
    const initialItemsGroupsArray = [];
    const groupsCount = itemsCount / itemsPerGroup;

    for (let i = 0; i < groupsCount; i++) {
        initialItemsGroupsArray.push([]);
    }

    return initialItemsGroupsArray;
};
